export const BOTTOM_SHEET_CLOSE_MS = 250;
export const BOTTOM_SHEET_ANIMATION_DURATION = "var(--transition-duration-sheet)";
export const BOTTOM_SHEET_TOGGLE_DEBOUNCE_MS = 300;
export const BOTTOM_SHEET_CLOSE_MS = 250;
export const BOTTOM_SHEET_ANIMATION_DURATION = "var(--transition-duration-sheet)";
export const BOTTOM_SHEET_TOGGLE_DEBOUNCE_MS = 300;
